const UrlMixin = {
	methods: {
		getImgUrl(pic) {
			return require('../assets/'+pic);
		}
	}
};

export default UrlMixin;